/*eslint quote-props: off*/

const tr = {
  event : {
    attributes:{
      id:                       'Id',
      abrupt_braking_count:     'Freadas bruscas',
      distance:                 'Distância',
      end_date:                 'Fim de percuso',
      event_type:               'Tipo de evento',
      fast_acceleration_count:  'Aceleração rápida',
      hard_turns_count:         'Curva perigosa',
      high_speed_count:         'Velocidade alta',
      max_speed_reached:        'Velocidade máxima',
      provider:                 'Provedor',
      start_date:               'Começo de percurso',
      use_phone_count:          'Uso de telefone',
      address:                  'Endereço',
      address_end:              'Endereço final',
      average_speed:            'Velocidade média',
    },
    extras:{
      title:                    'Linha do tempo',
      start_time:               'Horário de saída',
      end_time:                 'Horário de chegada',
      date:                     'Data',
      distance:                 'Distância',
      activity:                 'Atividades',
      max_speed:                'Velocidade máxima',
      events_count:             'Eventos',
      event_type:               'Tipo de evento',
      start_location:           'Local de saída',
      end_location:             'Local de chegada',
      route:                    'Percurso',
      location:                 'Localização',
      time:                     'Horário',
      stats_title:              'Estatísticas',
      events_title:             'Eventos',
      total_time:               'Tempo total',
      groups:                   'Grupos',
    },
    type_event:{
      in_vehicle:               'Em veículo',
      on_foot:                  'A pé',
      walking:                  'A pé',
      running:                  'Correndo',
      on_bicycle:               'De bicicleta',
      still:                    'Parado',
      private:                  'Privado',
      checkin:                  'Checkin',
      insufficient_data:        'Dados insuficientes',
    },
    date_filter:{
      today:                    'Hoje',
      seven_days:               'Últimos 7 dias',
      fifteen_days:             'Últimos 15 dias',
      last_month:               'Último mês',
      last_3_months:            'Últimos 3 meses',
      last_year:                'Último ano',
      all_time:                 'Todo o tempo',
    },

  },
};

export default tr;
